// extracted by mini-css-extract-plugin
export default {"copy-report-popup":"CopyReportPopup_copy-report-popup__+OQnk","popup-header":"CopyReportPopup_popup-header__ioaN8"};